<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Upload Calendar          
             <v-btn small color="warning" @click="downloadCSV()">Download Template</v-btn>
          </p>
          <div class="text--primary">
            <v-row>
              <v-col md="12" sm="12">
                <FilePond
                  name="test"
                  ref="pond"
                  class-name="my-pond"
                  label-idle="Click or Drop files here..."
                  accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv"
                  :files="this.FILE_UPLOAD"
                  :init="handleFilePondInit"
                  v-on:updatefiles="handleFilePondUpdateFile"
                  v-on:removefile="handleFilePondRemoveFile"
                />
              </v-col>
              <v-col md="12" sm="12">
                <v-btn
                  small
                  color="warning"
                  class="mb-3 float-right"
                  :disabled="canSubmit"
                  @click="confirmModal(submitUpload)"
                  >Submit Uploaded File</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-3">
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col class="py-0" md="12" sm="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Data"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col md="12" sm="12">
                <v-data-table
                  :headers="dtHeaders"
                  :items="JSON_FILE_UPLOAD"
                  :search="search"
                  v-bind:allow-multiple="false"
                  :loading="dtLoading"
                  :item-class="itemRowValidation"
                  loading-text="Fetching Data..."
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text>
          It will submit all data which is imported to database. Please give
          confirmation before you submit.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<style>
.not-valid {
  background-color: rgb(255, 210, 210);
}
td {
  white-space: nowrap;
}
</style>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";
import moment from "moment";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [{
    FULL_DATE: "",
    DAY_NAME: "",
    WEEK_CALL: "",
    HOLIDAY: ""
}, ];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      canExport: true,
      canSubmit: true,
      methodAction: "",
      isOpenModalConfirm: false,
      FILE_UPLOAD: [],
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
      dtHeaders: [
        {
          text: "Date",
          value: "Date",
        },
        {
          text: "MonthID",
          value: "MonthID",
        },
        {
          text: "YearID",
          value: "YearID",
        },
        {
          text: "Day",
          value: "Day",
        },
        {
          text: "Week",
          value: "Week",
        },
        {
          text: "IsDaysOff",
          value: "IsDaysOff",
        },
        {
          text: "isValid",
          value: "isValid",
        },
        {
          text: "Reason",
          value: "Reason",
        },
      ],
      dtItems: [],
      search: "",
    };
  },
  methods: {
    itemRowValidation: function (item) {
      return item.isValid ? "" : "not-valid";
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    handleFilePondInit() {},
    handleFilePondUpdateFile(file) {
      let self = this;
      let counter = true;

      const UPLOADED_CSV = file.map((fileItems) => fileItems.file);
      const userData = JSON.parse(localStorage.getItem("userData"));

      var files = UPLOADED_CSV,
        f = files[0];
      if (f) {
        var reader = new FileReader();
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          let sheetName = workbook.SheetNames[0];
          /* DO SOMETHING WITH workbook HERE */
          let worksheet = workbook.Sheets[sheetName];
          const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
          
          if (self.JSON_FILE_UPLOAD < 1) {
            for (let XLSXJSONDATA of XLSXJSON) {
              if (
                XLSXJSONDATA.FULL_DATE != undefined &&
                XLSXJSONDATA.DAY_NAME != undefined &&
                XLSXJSONDATA.WEEK_CALL != undefined &&
                XLSXJSONDATA.HOLIDAY != undefined 
              ) {
                
              let date = XLSXJSONDATA.FULL_DATE;

               let converted_date = new Date(Math.round((date - 25569) * 864e5));
                converted_date = String(converted_date).slice(4, 15)
                date = converted_date.split(" ")
                let day = date[1];
                let month = date[0];
                month = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(month) / 3 + 1
                let year = date[2];
                let fullDate = String(year + '-' + month + '-' + day)

                let VALIDITY = true;
                let VALIDITY_REASON = "";

                const listDay = [
                  "SENIN",
                  "SELASA",
                  "RABU",
                  "KAMIS",
                  "JUMAT",
                  "SABTU",
                  "MINGGU",
                ];

                if (!listDay.includes(XLSXJSONDATA.DAY_NAME)) {
                  VALIDITY = false;
                  VALIDITY_REASON = "Nama Hari tidak Sesuai";
                }

                if (XLSXJSONDATA.WEEK_CALL > 4) {
                  VALIDITY = false;
                  VALIDITY_REASON = "Week Tidak Sesuai";
                }
                let dayOff= 1;
                if(XLSXJSONDATA.HOLIDAY!=='NA'){
                  dayOff=1;
                }
                self.JSON_FILE_UPLOAD.push({
                  Date: fullDate,
                  MonthID: month,
                  YearID: parseInt(year),
                  Day: XLSXJSONDATA.DAY_NAME,
                  Week: XLSXJSONDATA.WEEK_CALL,
                  IsDaysOff: dayOff,
                  UserID: userData.USER_ID,
                  isValid: VALIDITY,
                  Reason: VALIDITY_REASON,
                });
              }
            }
            self.canSubmit = false;
          }
        };
        reader.readAsArrayBuffer(f);
      }
    },
    handleFilePondRemoveFile(error, file) {
      this.$refs.pond.removeFile();
      this.JSON_FILE_UPLOAD = [];
    },
    submitUpload() {
      if (this.JSON_FILE_UPLOAD.length > 0) {
        this.isOpenModalConfirm = false;
        this.isLoading = true;
        
        this.$http
          .post("/setting/uploadcalendar", this.JSON_FILE_UPLOAD, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            this.isLoading = false;
            const { success, data, message } = res.data;
            if (success) {
              this.canExport = false;
              this.canSubmit = true;
              this.dtItems = data;
              this.$refs.pond.removeFile();
              this.JSON_FILE_UPLOAD = [];
              this.showSnackbar(message);
            } else {
              this.showSnackbar(message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.showSnackbar(err.toString());
          });
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar("Template tidak sesuai !");
      }
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Upload Calendar.xlsx"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
